import { resetStores } from '@/src/hooks/resetStores';
import { CapacitorCookies } from '@capacitor/core';
import { userQueryKeys } from '@fabric-app/business/user/queries/userQueryKeys';
import { getDatabase } from '@fabric-app/compat';
import type { ApiUserMe } from '@fabric-app/types/user';
import { deleteAllCookies } from '@fabric-app/utils/cookies';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { mutate } from 'swr';

export const useUserClearCache = () => {
  const queryClient = useQueryClient();

  const clearCache = useCallback(async () => {
    /**
     * delete all cookies client side
     */
    deleteAllCookies();
    await CapacitorCookies.clearAllCookies();

    /**
     * reset zustand stores
     */
    await resetStores();

    /**
     * this is cleared later but just to make sure
     */
    queryClient.setQueryData<ApiUserMe>(userQueryKeys.userInfo(), () => {
      return undefined;
    });

    /**
     * clear query client cache
     */
    queryClient.clear();

    /**
     * clear database
     */
    getDatabase()?.clear('persistedQueries');

    // clear swr cache
    mutate(() => true, undefined, { revalidate: false });
  }, [queryClient]);

  return clearCache;
};
